<template>
	<nav aria-label="Pagination">
	  <ul class="pagination" v-if="pages > 1 && pages">
	  	<li class="page-item"><a class="page-link" href="#" v-on:click.prevent="gotoPage(1)"><i class="fa fa-step-backward"></i> Start</a></li>
	    <li :class="{disabled: currentPage == 1}" class="page-item"><a class="page-link" href="#" v-on:click.prevent="minusPage"> <i class="fa fa-caret-left"></i> Previous</a></li>

	    <li v-for="(p,i) in pages" v-if="pages && i > currentPage - 10 && i < currentPage + 8" :class="{'active': currentPage == p}" class="page-item page-button"><a class="page-link" href="#" v-on:click.prevent="gotoPage(p)">{{p}}</a></li>

	    <li :class="{disabled: currentPage == pages}" class="page-item"><a class="page-link" href="#" v-on:click.prevent="plusPage">Next <i class="fa fa-caret-right"></i></a></li>
	    <li class="page-item"><a class="page-link" href="#" v-on:click.prevent="gotoPage(pages)">Last <i class="fa fa-step-forward"></i></a></li>
	  </ul>
	</nav>
</template>

<script>

export default {
	name: 'Pagination',
	components: {},
	props: ["pages","currentPage"],
	data () {
		return {
			
		}
	},
	methods: {
		plusPage() {
			if (this.currentPage < this.pages || !this.pages)
				this.$emit("pageChange", this.currentPage+1)
		},
		minusPage() {
			if (this.currentPage > 1) 
				this.$emit("pageChange",this.currentPage-1)
			
		},
		gotoPage(page) {
			this.$emit("pageChange", page)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pagination {
		flex-wrap: wrap;
	}

	.page-link {
		color: var(--brand-primary-color);
	}

	.page-item.active .page-link {
		background-color: var(--brand-primary-color);
		border-color: var(--brand-primary-color);
		color: white;
	}

	.page-item.active {
		color: white;
	}

	@media (max-width: 800px) {
		.page-button {
			display: none;
		}

		.page-button.active {
			display: block;
		}
	}
</style>
